import {Serializer} from '~/app/core/common/serializers/serializer';
import {ConfirmationItem} from '~/app/core/common/models/confirmationitem';

export class ConfirmationSerializer implements Serializer {
    fromJson(json: any): ConfirmationItem {
        const confirmationItem = new ConfirmationItem();
        confirmationItem.description = json.description;
        confirmationItem.itemNumber = json.itemNumber;
        confirmationItem.price = json.price;
        confirmationItem.quantity = json.quantity;
        confirmationItem.reason = json.reason;
        confirmationItem.trackingId = json.trackingId;
        confirmationItem.totalPrice = confirmationItem.quantity * confirmationItem.price;
        return confirmationItem;
    }

    toJson(resource: ConfirmationItem) {
        return JSON.stringify(resource);
    }

}
